import React from "react";
import { Alert, AlertIcon, Box, Button, CloseButton, Flex, Text } from "@chakra-ui/react";
import { useTrialStatus } from "../../context/TrialStatusContext";
import { Trans, useTranslation } from "react-i18next";

// Centered banner inspired by Chakra UI examples
const TrialBanner = () => {
  const { accountStatus, trialDaysRemaining, trialEndsAt, isActive } = useTrialStatus();
  const [dismissed, setDismissed] = React.useState(false);
  const { t } = useTranslation("portal");

  const isTrial = accountStatus === "TRIAL" && typeof trialDaysRemaining === "number" && trialDaysRemaining >= 0;
  const showBanner = isTrial && trialDaysRemaining <= 7 && !dismissed; // threshold

  if (!showBanner) return null;

  const formattedDate = trialEndsAt ? new Date(trialEndsAt).toLocaleDateString() : null;

  return (
    <Box
      position="fixed"
      top="64px"
      left="50%"
      transform="translateX(-50%)"
      w="calc(100% - 32px)"
      maxW="900px"
      zIndex={1100}
    >
      <Alert
        borderRadius="md"
        bg="brand.50"
        border="1px solid"
        borderColor="brand.100"
        alignItems="center"
        py={2}
        px={3}
      >
        <AlertIcon color="brand.500" />
        <Flex align="center" justify="space-between" w="100%" gap={3}>
          <Text fontSize={{ base: "sm", md: "sm" }} transform="translateY(6px)">
            <b>{t("trialBanner.title")}</b>{" "}
            —{" "}
            <Trans
              ns="portal"
              i18nKey="trialBanner.message"
              count={trialDaysRemaining}
              components={{ b: <b /> }}
            >
              You have <b>{{ count: trialDaysRemaining }}</b> days left. Renew now to continue using the
              platform.
            </Trans>
            {formattedDate ? t("trialBanner.endsAt", { date: formattedDate }) : ""}
          </Text>
          <Flex align="center" gap={2} flexShrink={0}>
            <Button
              colorScheme="brand"
              size="sm"
              onClick={() =>
                window.open("mailto:contact@asap-app.ai?subject=Trial%20renewal", "_blank")
              }
            >
              {t("trialBanner.contactUs")}
            </Button>
            <CloseButton color="black" onClick={() => setDismissed(true)} />
          </Flex>
        </Flex>
      </Alert>
    </Box>
  );
};

export default TrialBanner;


